import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Input from '@lightspeed/cirrus-input';
import FormField from 'cirrus/FormField';
import get from 'lodash/get';

const NAME_MAX_LENGTH = '50';
const NAME_PARAMETER_ID = 'name';

export const ERROR_CODES = {
  UNABLE_TO_PAIR_TERMINAL: 'unable_to_pair_terminal',
  VALIDATION_ERROR: 'validation_error',
};

export const ERROR_MESSAGE = {
  UNABLE_TO_PAIR_TERMINAL: 'Activation Code is invalid.',
  VALIDATION_ERROR: 'The name may not be greater than 50 characters.',
};

const TERMINAL_FIELD_DESCRIPTION = {
  name: 'You may choose a unique name for this Payment Terminal',
  serialNumber: 'Enter the Serial Number of the device you are trying to pair',
  address: 'Enter the IP Address of the device',
  activationCode: 'Enter the Activation Code displayed on the terminal',
  terminalID: 'Enter the numeric Terminal ID if it was provided',
  merchantId: 'Press the Menu button on the terminal to find the Merchant ID',
};

class Fields extends Component {
  componentDidUpdate(prevProps) {
    const { ccTerminalErrors, setFieldError } = this.props;

    if (prevProps.ccTerminalErrors !== ccTerminalErrors) {
      ccTerminalErrors.forEach(apiError => {
        const errorCode = get(apiError, 'response.data.errorCode', '');

        if (errorCode === ERROR_CODES.UNABLE_TO_PAIR_TERMINAL) {
          setFieldError('activationCode', ERROR_MESSAGE.UNABLE_TO_PAIR_TERMINAL);
        }

        if (errorCode === ERROR_CODES.VALIDATION_ERROR) {
          setFieldError('name', ERROR_MESSAGE.VALIDATION_ERROR);
        }
      });
    }
  }

  render() {
    const { parameters, errors, handleBlur, handleChange, touched, values } = this.props;

    return (
      <Fragment>
        {parameters.map(parameter => (
          <FormField className="cr-mb-2" key={parameter.id}>
            <Input
              type="text"
              name={parameter.id}
              description={TERMINAL_FIELD_DESCRIPTION[parameter.id]}
              data-test={`retail-payments-ccterminal-${parameter.id}`}
              label={parameter.title}
              className="cr-width-full"
              suffix={
                parameter.id === NAME_PARAMETER_ID || parameter.required === 'true' ? '*' : null
              }
              status={
                touched[parameter.id] && errors[parameter.id]
                  ? { type: 'error', message: errors[parameter.id] }
                  : {}
              }
              onBlur={handleBlur}
              onChange={handleChange}
              value={values[parameter.id]}
              maxLength={parameter.id === NAME_PARAMETER_ID ? NAME_MAX_LENGTH : parameter.maxLength}
              placeholder={
                parameter.id !== NAME_PARAMETER_ID && parameter.required === 'false'
                  ? 'Optional'
                  : null
              }
            />
          </FormField>
        ))}
      </Fragment>
    );
  }
}

Fields.propTypes = {
  parameters: PropTypes.arrayOf(PropTypes.shape(PropTypes.any.object)),
  errors: PropTypes.shape(PropTypes.any.object),
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  touched: PropTypes.shape(PropTypes.any.object),
  values: PropTypes.shape(PropTypes.any.object),
  setFieldError: PropTypes.func,
  ccTerminalErrors: PropTypes.arrayOf(PropTypes.shape(PropTypes.any.object)),
};

Fields.defaultProps = {
  parameters: [],
  errors: {},
  handleBlur: () => {},
  handleChange: () => {},
  touched: {},
  values: {},
  setFieldError: () => {},
  ccTerminalErrors: [],
};

export default Fields;
